import Vue from "vue";
import Router from "vue-router";
import index from "./views/index.vue";

Vue.use(Router);

export default new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      component: index,
      children: [
        {
          path: "/payment-method-selection",
          name: "payment-method-selection",
          component: () =>
            import(
              /* webpackChunkName: "payment-method-selection" */ "./views/payment-method-selection.vue"
            ),
        },
        {
          path: "/payment-method-details/",
          name: "payment-method-details",
          component: () =>
            import(
              /* webpackChunkName: "payment-method-details" */ "./views/payment-method-details.vue"
            ),
        },
      ],
    },
    {
      path: "/payment-session-expired",
      name: "payment-session-expired",
      component: () =>
        import(
          /* webpackChunkName: "payment-session-expired" */ "./views/payment-session-expired.vue"
        ),
    },
    {
      path: "/payment-failure",
      name: "payment-failure",
      component: () =>
        import(
          /* webpackChunkName: "payment-failure" */ "./views/payment-failure.vue"
        ),
    },
    {
      path: "/payment-pending",
      name: "payment-pending",
      component: () =>
        import(
          /* webpackChunkName: "payment-pending" */ "./views/payment-pending.vue"
        ),
    },
  ],
});
